<script setup lang="ts">
  import { UiButton } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    id: string | undefined
    text: string
    buttonLabel: string
    onReset: () => void
  }>()
</script>

<template>
  <div v-if="id" class="mimic-banner">
    <div class="text">
      {{ text }}: <span class="bold">{{ id }}</span>
    </div>
    <UiButton @click="onReset" :label="buttonLabel" />
  </div>
</template>

<style scoped>
  .mimic-banner {
    background-color: var(--colours-support-warning);
    color: white;
    text-align: center;
    padding: 1rem;
    overflow: hidden;
    justify-items: center;
    flex-grow: 1;
  }

  .text {
    margin-bottom: 0.5rem;
  }

  .bold {
    color: white;
    font-weight: bold;
    font-size: 1.2rem;
  }
</style>
